// extracted by mini-css-extract-plugin
export default {"container":"FindPw_container__ffphL","findBox":"FindPw_findBox__3suxg","title":"FindPw_title__2OxOB","input":"FindPw_input__v58Ps","button":"FindPw_button__-eCkY"};